import { useSuiteStarterUpgrade } from 'trial-components-library/hooks/UpmarketMotion/useSuiteStarterUpgrade';
import { ButtonWithDemoExitConfirmation } from '../../../components/DemoExitConfirmation';
import useIsPaidPortal from '../../../hooks/useIsPaidPortal';
import { useIsProfessionalOrEnterpriseTrial } from '../../../hooks/useIsProfessionalOrEnterpriseTrial';
import { usePortal } from '../../../hooks/useNavConfig';
import { GrowthUpgradeButton } from './GrowthUpgradeButton';
import { newUpgradeListItemStyles } from './stylesheets';
import { trackUpgradeButtonClick } from './trackUpgradeButtonClick';
import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const UpgradeButton = ({
  shouldDisplay
}) => {
  const theme = useTheme();
  const {
    isPaidPortal
  } = useIsPaidPortal();
  const {
    isProOrEntTrial,
    isProOrEntTrialLoaded
  } = useIsProfessionalOrEnterpriseTrial();
  const [showSuiteStarterButton] = useSuiteStarterUpgrade(isPaidPortal, isProOrEntTrial);
  const {
    portalType
  } = usePortal();
  const isDevPortal = portalType === 'DEV';
  if (!shouldDisplay || !isProOrEntTrialLoaded) {
    return null;
  }
  return /*#__PURE__*/_jsx(ButtonWithDemoExitConfirmation, {
    component: GrowthUpgradeButton,
    shouldRender: showSuiteStarterButton && !isDevPortal,
    onClick: () => {
      trackUpgradeButtonClick();
    },
    itemName: "Suite Starter Upgrade Button",
    additionalListItemStyles: newUpgradeListItemStyles(theme)
  });
};